import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Card } from "@mui/material";
import OfficeImg from "../../Assets/office.jpg"; // Adjust the path as necessary
import TopNavBar from "../../Custom/TopNavBar";
import AvatarImg from "../../Assets/avatar-img.png"; // Default Avatar
import http from "../../../../../httpService"; // Assuming the API request is through this service
import { useParams } from "react-router-dom";
import "../../css/mobilecss.css"; // Mobile-specific styles
import CustomCursor from "../../Custom/CustomCursor";

const ProfileMobileView = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [boxHeight, setBoxHeight] = useState(window.innerHeight);
  const [portfolioId, setPortfolioId] = useState(""); // To hold the portfolio ID
  const { uuid } = useParams();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await http.get("/api/portfolio/employee/" + uuid, {
          headers: {
            Accept: "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        });
        if (response.data.success) {
          setProfile(response.data.data); // Set profile data
        } else {
          console.error("Failed to fetch profile data.");
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
      } finally {
        setLoading(false); // Set loading state to false after the request
      }
    };

    fetchProfile();
  }, [uuid]);

  useEffect(() => {
    const portfolioId = sessionStorage.getItem("portolioId");
    if (portfolioId) {
      setPortfolioId(portfolioId); // Pass it to the top navigation or set it in state
    }
  }, []);

  useEffect(() => {
    const updateHeight = () => {
      setBoxHeight(window.innerHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  if (loading) {
    return (
      <Typography sx={{ textAlign: "center", color: "white" }}>
        Loading...
      </Typography>
    );
  }

  if (!profile) {
    return (
      <Typography sx={{ textAlign: "center", color: "white" }}>
        No profile data available.
      </Typography>
    );
  }

  return (
    <>
      {/* Mobile View */}
      <Box
        sx={{
          position: "relative",
          minHeight: "100vh", // Minimum height to cover the entire viewport
          backgroundImage: `url(${OfficeImg})`,
          backgroundSize: "300% auto", // Set the background size to auto for height and 100% for width
          backgroundPosition: "center",
          backgroundRepeat: "repeat-y", // Repeat the background image along the Y-axis
          width: "100%", // Full width
          overflowY: "auto", // Allow vertical scrolling
          animation: "moveBackground 10s infinite linear", // Apply background animation
        }}
      >
        <TopNavBar uuid={portfolioId} />

        {/* Content Card for Mobile */}
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            backgroundColor: "rgba(126, 126, 126, 0.2)",
            borderRadius: "24px",
            minHeight: "100vh", // Make sure this takes full screen height
            width: "94%",
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backdropFilter: "blur(4px)",
            border: "1px solid rgba(234, 234, 234, 0.2)",
            mt: 1,
            mb: 1,
            padding: 2,
            // Allow vertical scrolling
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Card
              sx={{
                width: "100%",
                mt: 8,
                minHeight: "20vh",
                background: "rgba(103, 103, 103, .3)",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" }, // Responsive layout
                backdropFilter: "blur(25px)",
                borderRadius: "10px",
                padding: 2,
              }}
            >
              <Box
                sx={{
                  backdropFilter: "blur(5px)",
                  display: "flex",
                  background: "rgba(230, 230, 230, 0.1)",
                  boxShadow: "0px 4px 10px rgba(2, 2, 2, 0.3)",
                  width: { xs: "100%", sm: "48%" }, // Full width on small screens
                  height: { xs: "auto", sm: "100%" },
                  borderRadius: "10px",
                  padding: { xs: 0, sm: "0px 20px 0px 20px" },
                  justifyContent: "center", // Center content horizontally
                  alignItems: "center", // Center content vertically
                }}
              >
                <img
                  src={profile.image_url || AvatarImg}
                  alt="Profile"
                  style={{
                    width: "80%", // Adjusted for better display
                    height: "auto", // Maintain aspect ratio
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
              </Box>

              <Box
                sx={{
                  background: "transparent",
                  display: "flex",
                  width: { xs: "100%", sm: "70%" },
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center", // Center the content
                  pl: { xs: 0, sm: 3 },
                  pt: { xs: 2, sm: 0 },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "1rem",
                    color: "white",
                    mb: 1,
                    textAlign: "center", // Center the text
                  }}
                >
                  {profile.role}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "2rem",
                    fontWeight: "500",
                    color: "white",
                    lineHeight: 1.1,
                    mb: 2,
                    textAlign: "center", // Center the text
                  }}
                >
                  {profile.name}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "1rem",
                    color: "white",
                    textAlign: "center", // Center the text
                  }}
                >
                  Candidate ID: {profile.candidate_id}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    backdropFilter: "blur(15px)",
                    borderRadius: "10px",
                    mt: 1,
                    padding: "10px 12px",
                    color: "white",
                    textTransform: "capitalize",
                    fontFamily: "Poppins",
                    fontSize: ".8rem",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.7)",
                    },
                    display: "block", // Make the button block-level so it takes full width
                    marginLeft: "auto",
                    marginRight: "auto", // Center the button horizontally
                  }}
                  onClick={() => {
                    const url = profile.cv_url;
                    window.open(url, "_blank");
                  }}
                >
                  Download CV
                </Button>
              </Box>
            </Card>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 2, // space between cards
              width: "100%",
              flexWrap: "wrap", // fallback for smaller screens
            }}
          >
            <Card
              sx={{
                flex: 1,
                minWidth: "45%",
                background: "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(25px)",
                borderRadius: "15px",
                boxShadow: "1px 1px 10px 1px rgba(0, 0, 0, 0.2)",
                marginTop: 2,
                padding: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: { xs: "1rem", sm: "1.2rem" },
                  color: "white",
                  textShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
                  fontWeight: "200",
                  whiteSpace: "nowrap",
                }}
              >
                Location
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: { xs: "0.9rem", sm: "1.1rem" },
                  fontWeight: "500",
                  color: "white",
                  whiteSpace: "nowrap",
                  paddingTop: "4px",
                }}
              >
                {profile.location}
              </Typography>
            </Card>

            <Card
              sx={{
                flex: 1,
                minWidth: "45%",
                textAlign: "center",
                background: "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(25px)",
                borderRadius: "15px",
                boxShadow: "1px 1px 10px 1px rgba(0, 0, 0, 0.2)",
                marginTop: 2,
                padding: 2,
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: { xs: "2rem", sm: "2.5rem" },
                  color: "white",
                  textShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                {profile.year_of_experience}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                  color: "white",
                  fontWeight: "300",
                  paddingTop: "4px",
                }}
              >
                Years of Experience
              </Typography>
            </Card>
          </Box>
          <Box
            sx={{
              width: "100%",
              textAlign: "start",
              background: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(25px)", // Increased blur
              borderRadius: "10px",
              boxShadow: "1px 1px 10px 1px rgba(0, 0, 0, 0.2)",
              padding: 2,
              flex: 1,
              mt: 2,
            }}
          >
            <Typography
              sx={{
                fontSize: "1.5rem",
                fontFamily: "Poppins",
                color: "#FFFFFF",
              }}
            >
              Summary
            </Typography>
            <Typography
              sx={{
                fontSize: "1rem",
                fontFamily: "Poppins",
                color: "#DEDEDE",
                wordWrap: "break-word",
              }}
            >
              {profile.summary}
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(15px)",
              borderRadius: "10px",
              padding: 2,
              mt: 2,
              marginBottom: 1,
              flex: "1 1 auto",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: "1.4rem",
                fontWeight: "400",
                color: "white",
              }}
            >
              Tech Expertise
            </Typography>

            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: "0.95rem",
                color: "white",
                padding: "8px",
                borderRadius: "8px",
                lineHeight: 1.6,
                whiteSpace: "pre-wrap",
              }}
            >
              {profile.tech_expertise.join(", ")}
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(15px)",
              borderRadius: "10px",
              padding: 2,
              mt: 1,
              alignSelf: "stretch",
              marginBottom: 2,
              flex: "1 1 auto",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: "1.4rem",
                fontWeight: "400",
                color: "white",
                mb: 1,
              }}
            >
              Certifications
            </Typography>

            {profile.certifications?.map((cert, index) => (
              <Typography
                key={index}
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "0.93rem",
                  color: "white",
                  padding: "8px",
                  borderRadius: "8px",
                  lineHeight: 1.2,
                  whiteSpace: "pre-wrap",
                }}
              >
                {cert}
              </Typography>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ProfileMobileView;
